import { Button } from "@/components/ui/Button/Button"

// Load Icon
import PlusIcon from '@/assets/svgs/plus.svg?react';
import { useTranslation } from "react-i18next";
import { useResponsive } from "@/utils/useResponsive";

const AddProductButton = ({ landingPageUrl, full }: { landingPageUrl: string, full: boolean }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Button
      label={t("buttons.addProduct")}
      onClick={() => { window.open(landingPageUrl, '_blank') }}
      primary
      backgroundColor={'#0000C8'}
      size={full && isMobile ? 'full' : 'large'}
      icon={<PlusIcon />}
    />
  );
}

export default AddProductButton;
